export const common = {
    LABELS: {
        ORGANIZED_BY: 'Organized by',
        LOADING: 'Loading...',
        APPLY: 'Apply',
        CLEAR: 'Clear',
        CANCEL: 'Cancel',
        VIEW_ALL: 'View All',
        NO_DATA: 'No data available',
        NO_FILTER: 'No Filter available',
        SORT_BY: 'Sort By',
        SORT_OPTION: 'Select Sort Option',
        ANY_ALL: 'Any / All',
        LOCATION: 'Location',
        ACCOMMODATION: 'Accommodation',
        COST_PER_PERSON: 'Cost (Per Person)',
        NIGHT_LABEL: '+ Nights',
        KNOW_MORE: 'Know More',
        COST: 'Cost',
        SAFARIS: 'Safaris',
        MEAL: 'Meals',
        THEME: 'Theme',
        TRIP_DURATION: 'Trip Duration',
        NIGHTS: 'Nights',
        DAYS: 'Days',
    },
    HEADER: {
        MAIN_MENU: {
            PLAN_SAFARI: 'Plan Safari',
            SAFARI_PACKAGE: 'Safari Packages',
            SHARED_SAFARI: 'Shared Safari',
        },
        USER_MENU: {
            PROFILE: 'Profile',
            ACCOUNT_SETTING: 'Account Setting',
            WISHLIST: 'Wishlist',
            LOG_OUT: 'Log Out',
            LOG_IN_WEB: 'Log in',
            LOG_IN_MOBILE: 'Login',
            MESSAGE: 'Message',
            YOU: 'You',
        },
    },

    FOOTER: {
        ABOUT: {
            TITLE: 'About Us',
            TEXT_1: 'We offer a seamless experience, connecting you with multiple safari tour operators and providing all the essential details you need to make informed decisions about your wildlife safari, all at no cost.',
            TEXT_2: 'Our shared safari feature connects you with fellow safari enthusiasts, enabling you to form a group and embark on a shared safari adventure together.',
        },
        POLICY: {
            TITLE: 'Policy',
            PRIVACY_POLICY: 'Privacy Policy',
            TERMS_CONDITIONS: 'Terms & Conditions',
            REFUND_POLICY: 'Refund Policy',
        },
        LINKS: {
            TITLE: 'Useful Links',
            ABOUT_US: 'About Us',
            CONTACT_US: 'Contact us',
            FAQS: 'FAQs',
        },
        CONTACT_INFO: {
            TITLE: 'Contact Info',
            ADDRESS_LABEL: 'Address',
            ADDRESS: 'New Delhi, India',
            EMAIL_LABEL: 'Email',
            EMAIL: 'support@walkintothewild.in',
            WEBSITE: 'walkintothewild.in',
            DEVELOPED_BY: 'DEVELOPED BY MEDIARC TECHNOLOGIES PRIVATE LIMITED',
            COPYRIGHT: 'COPYRIGHT © 2025 | ALL RIGHTS RESERVED',
        },
        SOCIAL: {
            INSTAGRAM: 'https://www.instagram.com/walkintothewild.in/',
            EMAIL: 'mailto:support@walkintothewild.in',
        },
    },

    PARK_SESSION: {
        BANNER: {
            TITLE_1: 'The Best of Wildlife',
            TITLE_2: 'Top Safari Parks',
        },
        NO_DATA: 'No parks available',
    },

    ANIMAL_SAFARI: {
        BANNER: {
            TITLE_TEXT_1: 'RARE AND EXOTIC',
            TITLE_TEXT_2: 'ANIMAL SAFARIS',
        },
        RARE_ANIMAL: {
            KNOW_MORE_BUTTON: 'Know More',
            NO_DATA: 'No animal safari available',
        },
    },

    HOME_BANNER: {
        HEADING: 'Find, plan and share Safaris - Your Ultimate Portal to the Wild',
        SEARCH: {
            SELECT_PARK: 'Select Park',
            OR: 'OR',
            LOCATION: 'Location',
            ANIMAL: 'Animal',
            VEHICLE: 'Vehicle',
            SEARCH_BUTTON: 'Search',
        },
    },

    SHARED_SAFARI: {
        HOME: {
            BANNER: 'Discover and Join Shared Safaris',
            VIEW_ALL_BUTTON: 'View All',
            NO_DATA: 'No safaris available',
            CARD: {
                FIXED_DEPARTURE: 'Fixed Departure',
                SAFARI: 'Safari',
                SEAT: 'Seat',
                ORGANIZED_BY: 'Organized by',
                UPDATE_BUTTON: 'Update',
                APP_BUTTON: 'App',
                JOIN_BUTTON: 'Join Safari',
            },
        },
        MAIN: {
            TITLE: 'Join or Organize a Shared Safari',
            ORGANIZED_BUTTON: '+ Organize a Shared Safari',
            SHARED_TEXT_1: 'There are currently',
            SHARED_TEXT_2: 'active shared safaris',
            FILTER_TEXT: 'Filter',
            NO_SAFARI: 'No safaris available',
            LOAD_MORE: 'Loading...',
            MORE_SAFARI_BUTTON: 'Show More Safaris',
            SELECTED_FILTERS: {
                PRICE: ' Rs',
                SAFARI: 'Safari',
            },
            FILTER: {
                TITLE: 'Select Filters',
                SAFARI_PARK: 'Safari Park',
                MONTH: 'Month',
                TYPE: 'Type',
                ANY_ALL: 'Any / All',
                NO_FILTER: 'No Filter available',
                BUDGET_PER_PERSON: 'Budget Price Per Person',
                TOTAL_SAFARI: 'Total Safaris',
                THEME: 'Theme',
                ORGANIZER: 'Organizer',
                CATEGORY: 'Stay Category',
            },
            MOBILE_FILTER: {
                TITLE: 'Select Filters',
                SAFARI_PARK: 'Safari Park',
                MONTH: 'Month',
                TYPE: 'Type',
                NO_FILTER: 'No Filter available',
                BUDGET_PER_PERSON: 'Budget Price Per Person',
                TOTAL_SAFARI: 'Total Safaris',
                THEME: 'Theme',
                ORGANIZER: 'Organizer',
                CATEGORY: 'Stay Category',
                SORT_BY: 'Sort By',
                SORT_OPTION: 'Select Sort Option',
                LOAD_MORE: 'Loading...',
                APPLY_BUTTON: 'Apply',
                CLEAR_BUTTON: 'Clear',
                CANCEL_BUTTON: 'Cancel',
                ANY_ALL: 'Any / All',
            },
        },
        VIEW: {
            SAFARI_HEADER: {
                ORGANIZED_BY: 'Organized by',
                TRIP_DURATION: 'Trip Duration',
                SEAT: 'Seats',
                AVAILABLE_SEAT: 'Available Seats',
                SAFARIS: 'Safaris',
                SHARED_SAFARI: 'Shared Safari',
                MEAL: 'Meals',
                THEME: 'Theme',
                ACCOMMODATION: 'Accommodation',
                COST: 'Cost',
                SAFARI_TEXT: 'Share this event with your friends',
                COST_PER_PERSON: 'Per Person',
                UPDATE_BUTTON: 'Update',
                JOIN_BUTTON: 'Join Safari',
            },
        },
    },

    SAFARI_PACKAGE: {
        HOME: {
            BANNER: 'Discover The Best Safari Deals',
            VIEW_ALL_BUTTON: 'View All',
            NO_DATA: 'No Package available',
            CARD: {
                DETAILS_BUTTON: 'View Details',
            },
        },
        MAIN: {
            TITLE: 'Wildlife Safari tour packages',
            SAFARI_TEXT_1: 'There are currently',
            SAFARI_TEXT_2: 'active packages',
            FILTER_TEXT: 'Filter',
            NO_FILTER: 'No Filter available',
            NO_PACKAGE: 'No Package available',
            LOAD_MORE: 'Loading...',
            MORE_PACKAGE_BUTTON: 'Show More Package',
            SELECTED_FILTERS: {
                NIGHT: 'Nights',
                SAFARI: 'Safari',
                COST: 'Cost',
            },
            FILTER: {
                TITLE: 'Select Filters',
                PARK: 'Park',
                MONTH: 'Month',
                STAY_CATEGORY: 'Stay Category',
                TOUR_DURATION: 'Tour Duration',
                TOTAL_SAFARIS: 'Total Safaris',
                COST_PER_PERSON: 'Cost (Per Person)',
                FEATURES: 'Features',
                INCLUDED: 'Included',
                ANY_ALL: 'Any / All',
                NO_FILTER: 'No Filter available',
                NIGHT: 'Night',
                NIGHT_LABEL: '+ Nights',
            },
            MOBILE_FILTER: {
                TITLE: 'Select Filters',
                SORT_BY: 'Sort By',
                SORT_OPTION: 'Select Sort Option',
                LOAD_MORE: 'Loading...',
                PARK: 'Safari Park',
                MONTH: 'Month',
                STAY_CATEGORY: 'Stay Category',
                TOUR_DURATION: 'Tour Duration',
                TOTAL_SAFARIS: 'Total Safaris',
                COST_PER_PERSON: 'Cost (Per Person)',
                FEATURES: 'Features',
                INCLUDED: 'Included',
                ANY_ALL: 'Any / All',
                NO_FILTER: 'No Filter available',
                NIGHT: 'Night',
                NIGHT_LABEL: '+ Nights',
                APPLY_BUTTON: 'Apply',
                CLEAR_BUTTON: 'Clear',
                CANCEL_BUTTON: 'Cancel',
            },
        },
        VIEW: {
            MAIN_HEADER: {
                ORGANIZED_BY: 'Organized by',
            },
            PACKAGE_CARD: {
                ORGANIZED_BY: 'Organized by',
                COST_PER_PERSON: 'Per Person',
                TRIP_DURATION: 'Trip Duration',
                NIGHTS: 'Nights',
                DAYS: 'Days',
                PICK_DROP: 'Pick & Drop',
                SAFARIS: 'Safaris',
                GYPSY_SAFARI: 'Shared Gypsy Safari',
                MEAL: 'Meals',
                THEME: 'Theme',
                PHOTO_APISE: 'Photography Special',
                ACCOMMODATION: 'Accommodation',
                PACKAGE_TEXT: 'Share this package with your friends',
            },
        },
    },

    ALL_PARKS: {
        PARK_TEXT_1: 'We found',
        PARK_TEXT_2: 'Parks',
        PARK_TEXT_3: 'for you',
        FILTER_TEXT: 'Filter',
        SELECTED_FILTER: 'Select Filters',
        ACCOMMODATION: 'Accommodation',
        NO_FILTER: 'No Filter available',
        BONUS_EXPERIENCE: 'Bonus Experience',

        MOBILE_FILTER: {
            SORT_BY: 'Sort By',
            SORT_OPTION: 'Select Sort Option',
            LOAD_MORE: 'Loading...',
            APPLY_BUTTON: 'Apply',
            CLEAR_BUTTON: 'Clear',
            CANCEL_BUTTON: 'Cancel',
        },
        PARKS: {
            PARK_TEXT_1: 'We found',
            PARK_TEXT_2: 'Parks',
            PARK_TEXT_3: 'for you',
            NO_FILTER: 'No Filter available',
            LOCATION: 'Location',
            WILD_LIFE: 'Wildlife Found',
            COST: 'Safari Cost',
            PRICE: 'Average Safari Price*',
            KNOW_MORE_BUTTON: 'Know More',
            NO_DATA: 'No Park available',
            LOAD_MORE: 'Loading...',
        },
        PARK_VIEW: {
            TOOL_TEXT: 'Submit correction if found wrong information!',
            LOCATION: 'Location',
            RAILWAY: 'Nearest Railway Station',
            AIRPORT: 'Nearest Airport',
            SAFARI_MODE: 'Safari Mode',
            SESSION: 'Safari Session',
            WILD_LIFE: 'Wildlife Found',
            COST: 'Safari Cost',
            PRICE: 'Average Safari Price*',
            OPERATOR: 'Subject to operator discretion',
            MONTH: 'Closed Months',
        },
    },

};